<div class="notification-popup" (click)="onClose()">
  <div class="popup-content" (click)="$event.stopPropagation()">
    <!-- Header Section -->
    <div class="popup-header">
      <div class="header-tabs">
        <button 
          class="tab-button" 
          [class.active]="activeTab === 'ACTIVE'"
          (click)="setActiveTab('ACTIVE')">
          <span class="tab-label">Inbox</span>
          <span class="unread-badge" *ngIf="unreadCount > 0">{{ unreadCount }}</span>
        </button>
        <div class="tab-divider"></div>
        <button 
          class="tab-button" 
          [class.active]="activeTab === 'ARCHIVED'"
          (click)="setActiveTab('ARCHIVED')">
          <span class="tab-label">Archived</span>
        </button>
        <div class="tab-divider"></div>
        <button 
          class="tab-button" 
          [class.active]="activeTab === 'ALL'"
          (click)="setActiveTab('ALL')">
          <span class="tab-label">All</span>
        </button>
      </div>
      <button class="close-btn" (click)="onClose()" aria-label="Close">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M15.7123 16.773L7.22699 8.28777C6.93708 7.99785 6.93708 7.51702 7.22699 7.22711C7.51691 6.93719 7.99774 6.93719 8.28765 7.22711L16.7729 15.7124C17.0628 16.0023 17.0628 16.4831 16.7729 16.773C16.483 17.063 16.0022 17.063 15.7123 16.773Z" fill="#292D32"/>
          <path d="M7.22706 16.773C6.93715 16.4831 6.93715 16.0023 7.22706 15.7124L15.7123 7.22711C16.0023 6.93719 16.4831 6.93719 16.773 7.22711C17.0629 7.51702 17.0629 7.99785 16.773 8.28777L8.28772 16.773C7.99781 17.063 7.51698 17.063 7.22706 16.773Z" fill="#292D32"/>
          </svg>
          
      </button>
    </div>
    <div class="header-divider"></div>

    <!-- Action Buttons -->
    <div class="action-buttons">
      <button class="action-btn" (click)="markAllAsRead()">
        Mark all as read
      </button>
      <button class="action-btn" (click)="archiveRead()">
        Archive read
      </button>
    </div>

    <!-- Notifications List -->
    <div class="notifications-container">
      <div *ngIf="loading" class="loading-state">
        Loading notifications...
      </div>
      <div *ngIf="!loading && notifications.length === 0" class="notifications-list">
        <div class="notification-item empty-state-item">
          <div class="notification-content">
            <div class="notification-details">
              <div class="notification-message empty-state-message">
                There are no Notifications available at this moment.
              </div>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="!loading && notifications.length > 0" class="notifications-list">
        <div 
          class="notification-item" 
          *ngFor="let notification of notifications"
          [class.unread]="!notification.isRead || notification.status === 'unread'">
          <div class="notification-content">
            <div class="unread-indicator" *ngIf="!notification.isRead || notification.status === 'unread'"></div>
            <div class="notification-details">
              <div class="notification-title" [class.error]="notification.type === 'error'">
                {{ notification.title }}
              </div>
              <div class="notification-message">
                {{ notification.message }}
              </div>
              <div class="notification-meta">
                <span class="notification-time">{{ formatTimeAgo(notification.timestamp || notification.date) }}</span>
                <span class="notification-label" *ngIf="notification.label">
                  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                    <path d="M7 0L8.5 5H14L9.75 8L11.25 13L7 10L2.75 13L4.25 8L0 5H5.5L7 0Z" fill="rgba(55, 53, 47, 0.45)"/>
                  </svg>
                  {{ notification.label }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
